import { withInstall } from '@zoryn/utils'
import GridTree from './src/grid-tree'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZGridTree: SFCWithInstall<typeof GridTree> = withInstall(GridTree)
export default ZGridTree

export type {
  GridTreeOptions,
  GridTreeConfig,
  GridColumnProps,
  GridColumnInfo,
  DataGridTree,
} from './src/types'
export { GridTreeOption } from './src/grid-tree-option'
export type { GridTreeOptionConfig } from './src/grid-tree-option'
